import DashboardActionTypes from './types';

export const fetchApplicationReportSuccess = (statistics) => ({
  type: DashboardActionTypes.FETCH_APPLICATION_REPORT_SUCCESS,
  payload: statistics,
});

export const fetchFinancialReportSuccess = (statistics) => ({
  type: DashboardActionTypes.FETCH_FINANCIAL_REPORT_SUCCESS,
  payload: statistics,
});

export const fetchStatisticFailure = (error) => ({
  type: DashboardActionTypes.FETCH_STATISTICS_FAILURE,
  payload: error,
});

export const fetchDashboardStatistics = (query) => ({
  type: DashboardActionTypes.FETCH_DASHBOARD_STATISTICS,
  payload: query,
});

export const fetchFinancialReport = (query) => ({
  type: DashboardActionTypes.FETCH_FINANCIAL_REPORT,
  payload: query,
});

// export dashboard report
export const exportReport = (data) => ({
  type: DashboardActionTypes.EXPORT_DASHBOARD_START,
  payload: { data },
});
export const exportReportSuccess = () => ({
  type: DashboardActionTypes.EXPORT_DASHBOARD_SUCCESS,
});
export const exportReportFailure = (error) => ({
  type: DashboardActionTypes.EXPORT_DASHBOARD_FAILURE,
  error,
});
